import React, { useEffect, useRef, useState } from 'react'
import { useMyContext } from '../../../components/Provider/CommonProvider'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Defaultloadinggif from '../../../layout/Others/Defaultloadinggif'
import AdminBackNavigation from '../../../components/CommonComponents/AdminBackNavigation'
import AdminSaveHeader from '../../../components/CommonComponents/AdminSaveHeader'
import Response_Processing from '../../../layout/Others/Response_Processing'
import FormContainer from '../../../components/CommonComponents/FormContainer'
import LeftWrapper from '../../../components/CommonComponents/LeftWrapper'
import Wrapper from '../../../components/CommonComponents/Wrapper'
import { slugGenerator } from '../../../components/CommonMethod/CommonMethods'
import AdminCustomInput from '../../../components/CommonComponents/AdminCustomInput'
import MessageLabel from '../../../components/CommonComponents/MessageLabel'
import MessageHeading from '../../../components/CommonComponents/MessageHeading'
import AdminCustomSelect from '../../../components/CommonComponents/AdminCustomSelect'
import MessageSubHeading from '../../../components/CommonComponents/MessageSubHeading'
import AdminImageUploadZone from '../../../components/CommonComponents/AdminImageUploadZone'
import AdminCustomButton from '../../../components/CommonComponents/AdminCustomButton'
import RightWrapper from '../../../components/CommonComponents/RightWrapper'
import useCompressImageConfig from '../../../components/CommonApis/Compressimageapi'
import "./AudioList.css";
import AdminCustomURLCopy from '../../../components/CommonComponents/AdminCustomURLCopy'
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from '../../../CustomFields/saveCustomFieldsStrict'
import { getItemToken } from '../../../Utils/localStorageUtils'

const AudioAlbumAddUpdate = () => {
    const { compressResolutionFormat } = useCompressImageConfig();
    const { fetchRequest, globalImageUplaodAPI } = useMyContext()
    const { id } = useParams()
    const headers = getItemToken('access_token')
    const { location } = useLocation()
    const navigate = useNavigate()
    const baseURL = process.env.REACT_APP_Baseurl

    const references = `${baseURL}/admin/album/create`;
    const labelApi = `${baseURL}/admin/Label-Management/list-source`
    const storeApi = `${baseURL}/admin/album/store`
    const imageUploadApi = globalImageUplaodAPI()
    const copyRightUploadApi = `${baseURL}/admin/album/copyrights`
    const editApi = `${baseURL}/admin/album/edit`
    const updateApi = `${baseURL}/admin/album/update`

    const [formData, setFormData] = useState({ name: "", slug: "", artist_type: "", artist_email: "", description: "" })
    const [formDataError, setFormDataError] = useState({})
    const [labelDisplay, setLabelDisplay] = useState([]);
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [defaultOption, setDefaultOption] = useState({
        categoryOption: []
    })
    const [coverImageFile, setCoverImageFile] = useState(null);

    const [showOverlay, setShowOverlay] = useState(false);
    const [loading, setLoading] = useState(true)
    const [customFieldValues, setCustomFieldValues] = useState({})

    const combinedRef = useRef({});
    const handleInput = async (e) => {
        const { name, value, type, checked } = e.target;

        if (type === "checkbox") {
            setFormData((prev) => ({
                ...prev,
                [name]: checked ? 1 : 0,
            }));
        }

        if (type === 'text') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }

        if (type === 'select-one') {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
            setFormDataError((prev) => ({
                ...prev,
                [name]: '',
            }));
        }

        if (type === "textarea") {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }

    };
    const generateSlug = async (title) => {
        const slug = await slugGenerator(title)
        setFormData((prev) => ({
            ...prev,
            'slug': slug,
        }));
    };
    const handleInputKeyDowntitle = (event) => {
        if (!formData?.slug) {
            if (event.key === "Enter" || event.key === "Tab") {
                generateSlug(formData?.albumname);
            }
        }
    };
    const handleBlurEdittitle = () => {
        generateSlug(formData?.slug);
    }

    const handleBlurtitle = () => {
        if (!formData?.slug) {
            generateSlug(formData?.albumname);
        }
    };
    const validateImageRatio = (file, expectedRatio, expectedWidth, expectedHeight) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);
            img.onload = () => {
                const width = img.width;
                const height = img.height;
                const ratio = width / height;
                const expectedRatioPrecision = 0.01;
                const ratioMatch = Math.abs(ratio - expectedRatio) < expectedRatioPrecision;
                const dimensionMatch = (width === expectedWidth && height === expectedHeight);
                if (ratioMatch || dimensionMatch) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            };
            img.onerror = () => {
                reject(new Error('Error loading image'));
            };
        });
    };

    const handleFileChange = async (event) => {
        const { files, name } = event.target
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
        setFormDataError((prev) => ({
            ...prev,
            [name]: "",
        }));
        if (files?.length > 0) {
            const newFile = files[0];

            if (
                (['image'].includes(name)) &&
                !allowedTypes.includes(files[0]?.type)
            ) {
                setFormDataError((prev) => ({
                    ...prev,
                    [name]: "Only JPG, JPEG, and PNG files are allowed.",
                }));

                if (name === 'image') setCoverImageFile(null);

                combinedRef.current[name]?.focus();
                return;
            }

            if (name == "image") {
                const reader = new FileReader();
                const readFile = (file) => {
                    return new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = () => resolve(reader.result);
                        reader.onerror = (error) => reject(error);
                        reader.readAsDataURL(file);
                    });
                };
                await readFile(newFile);
            }
            const checkSize = compressResolutionFormat?.audios === 1

            if (name == 'image') {
                const isValidSizeEqual = await validateImageRatio(newFile, 1 / 1, 1080, 1080);
                setCoverImageFile(newFile);
                setFormData((prev) => ({
                    ...prev,
                    ['album']: newFile
                }))
                if (!allowedTypes.includes(files[0]?.type)) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Only JPG, JPEG, and PNG files are allowed.",
                    }));
                    combinedRef.current['image'].focus()
                    return;
                }
                if (checkSize && !isValidSizeEqual) {
                    setFormDataError((prev) => ({
                        ...prev,
                        [name]: "Image must be in 1:1 Ratio or 1080px (x) 1080px",
                    }));
                    combinedRef.current['image'].focus()
                    return;
                }
            }
        }
    }
    const handleClearSelectFile = (value) => {
        if (value == 'image') {
            setCoverImageFile(null)
        }
        if (value == 'copyright') {
            setSelectedFile1(null)
        }
        setFormDataError((prev) => ({
            ...prev,
            [value]: ""
        }))
    }

    const fileInputRef1 = useRef(null);
    const [selectedFile1, setSelectedFile1] = useState(null);

    const allowedPDF = ["application/pdf"];

    const handlePDFChange = (event, fileInputRef, setSelectedFile, fieldKey) => {
        const file = event.target.files[0];
        if (file) {
            if (!allowedPDF.includes(file.type)) {
                setFormDataError((prev) => ({
                    ...prev,
                    [fieldKey]: "Only PDF files are allowed.",
                }));
                fileInputRef.current.value = null;
                setSelectedFile(null);
                return;
            }
            setSelectedFile(file);
            setFormDataError((prev) => ({
                ...prev,
                [fieldKey]: "",
            }));
        }
    };

    const handleDelete = (index) => {
        if (index === 1) {
            setSelectedFile1(null);
            if (fileInputRef1.current) {
                fileInputRef1.current.value = null;
            }
        }
    };

    const labelFetch = async () => {
        try {
            setLoading(true)
            await fetchRequest({
                method: 'GET',
                url: `${labelApi}`,
                params: { source: "album-label" },
                data: {},
            }).then((res) => {
                setLabelDisplay(res?.label_management)
            })
        }
        catch (err) {
            toast.error(err?.response?.data?.message)
        }
        finally {
            setLoading(false)
        }
    }
    const formValidation = () => {
        let formIsValid = true;
        if (!formData?.albumname) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                albumname: "Album name cannot be empty.",
            }));
            combinedRef.current['albumname'].focus()
            formIsValid = false;
        } else if (!formData?.slug) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                slug: "Album Slug cannot be empty.",
            }));
            combinedRef.current['slug'].focus()
            formIsValid = false;
        }
        if (formDataError?.image) {
            combinedRef.current['image'].focus()
            formIsValid = false;
        }
        if (compressResolutionFormat?.audios === 1) {
            if (id && !formData?.album || !id && !coverImageFile) {
                setFormDataError(prev => ({
                    ...prev,
                    image: "Please provide cover image"
                }));
                combinedRef.current['image'].focus();
                formIsValid = false;
            }
        }
        if (!formData?.albumname || formData?.albumname.trim().length < 3 || formData?.albumname.trim().length > 100) {
            toast.error("Name must be between 3 and 100 characters.");
            formIsValid = false;
        }
        if (!formData?.slug || formData?.slug.trim().length < 3 || formData?.slug.trim().length > 100) {
            formIsValid = false;
        }
        return formIsValid;
    }

    const handleImageUpload = async (id, name) => {
        const formData = new FormData();
        const imageFields = [];
        formData.append("id", id);
        formData.append("modelName", "AudioAlbum");
        if (name == 'image') {
            formData.append("album", coverImageFile);
            imageFields.push("album");
            imageFields.forEach((field) => {
                formData.append('imageFields[]', field);
            });
        }
        if (name == 'copyright') formData.append("copyright", selectedFile1);

        let findApi = name == "image" ? `${imageUploadApi}` : name == "copyright" ? `${copyRightUploadApi}/${id}` : ''
        await fetchRequest({
            method: 'POST',
            url: `${findApi}`,
            params: {},
            data: formData,
        })
            .then(response => {
                if (response?.status) {
                    setCoverImageFile(null)
                    setSelectedFile1(null)
                }
            }).catch((err) => {
                toast.error(err?.response?.data?.message)
            })
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        if (formValidation()) {
            handleAction()
        }
        else {
            console.table("validation")
        }
    }

    const handleAction = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (formData.hasOwnProperty(key)) {
                    formDataAdd[key] = formData[key];
                }
            }

            const response = await fetchRequest({
                method: `${id ? 'PATCH' : 'POST'}`,
                url: `${id ? `${updateApi}/${id}` : storeApi}`,
                params: {},
                data: formDataAdd,
            });

            if (response?.status) {
                // save custom field values (strict)
                try {
                    await saveCustomFieldsStrict({ baseURL, headers, entityType: 'album', entityId: id || response?.id, values: customFieldValues });
                } catch (e) {
                    toast.error(e?.response?.data?.message || e?.message || 'Failed to save additional fields');
                    setShowOverlay(false);
                    return;
                }
                if (coverImageFile) {
                    await handleImageUpload(response?.id, 'image');
                }
                if (selectedFile1) {
                    await handleImageUpload(response?.id, 'copyright');
                }
                toast.success(response?.message);
                if (!id) {
                    navigate("/manage-albums");
                }
                else {
                    setWithOutRefresh(prev => !prev)
                }
            }

        } catch (error) {
            toast.error(error?.response?.data?.message || 'An error occurred.');
        } finally {
            setShowOverlay(false);
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            if (!id) {
                setLoading(true)
                await fetchRequest({
                    method: 'GET',
                    url: `${references}`,
                    params: {},
                    data: {},
                })
                    .then(response => {
                        if (response?.status) {
                            setDefaultOption((prev) => ({
                                ...prev,
                                categoryOption: response?.audio_albums
                            }))
                        }
                    }).catch((error => {
                        toast.error(error?.response?.data?.message)
                    })).finally(() => {
                        setLoading(false)
                    })
            }
            else {
                setLoading(true)
                await fetchRequest({
                    method: 'GET',
                    url: `${editApi}/${id}`,
                    params: {},
                    data: {},
                })
                    .then(response => {
                        if (response?.status) {
                            setDefaultOption((prev) => ({
                                ...prev,
                                categoryOption: response?.albums
                            }))
                            setFormData(response?.audio_album)
                        }
                    }).catch((error => {
                        toast.error(error?.response?.data?.message)
                    })).finally(() => {
                        setLoading(false)
                    })
            }
        }
        fetchData();
    }, [withOutRefresh, location]);

    useEffect(() => {
        labelFetch()
    }, [])

    if (loading) {
        return <Defaultloadinggif className={"heightOnLoader"} />
    }

    return (
        <div>
            {showOverlay && (<Response_Processing />)}
            <AdminBackNavigation text="Back" path="/manage-albums" />
            <AdminSaveHeader loading={showOverlay} heading={!id ? labelDisplay?.[0]?.title : labelDisplay?.[0]?.sub_title} saveText={!id ? labelDisplay?.[0]?.title : labelDisplay?.[0]?.sub_title} saveMethod={handleSubmit} />
            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={!id ? labelDisplay?.[1]?.title : formData?.albumname} />
                        <MessageLabel text={labelDisplay?.[2]?.title} className="mandatorySimple" />
                        <AdminCustomInput type="text" name="albumname" value={formData?.albumname} onChange={handleInput} placeHolder={"Album Name"} ref={(el) => (combinedRef.current.albumname = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.albumname} id="albumName" />
                        <MessageLabel text={labelDisplay?.[3]?.title} className="mandatorySimple" />
                        <AdminCustomInput type="text" name="slug" value={formData?.slug} onChange={handleInput} onBlur={handleBlurEdittitle} placeHolder={"Album  Slug"} ref={(el) => (combinedRef.current.slug = el)} error={formDataError?.slug} id="albumSlug" />
                        <MessageLabel text={labelDisplay?.[4]?.title} />
                        <AdminCustomSelect name="parent_id" value={formData?.parent_id} onChange={handleInput} ref={(el) => (combinedRef.current.parent_id = el)} options={defaultOption?.categoryOption?.map((item) => ({ name: item.albumname, value: item.id }))} error={formDataError?.parent_id} defaultOptionName={"Choose an sub album"} id="subAlbum" />

                        <div className="card p-3 mt-3">
                            {/* <MessageHeading text="Additional Fields" /> */}
                            {/* Custom fields */}
                            <FieldRenderer2
                                pageIdentifier={id ? "album.edit" : "album.create"}
                                entityType="album"
                                entityId={id}
                                text="Additional Fields"
                            />
                            <FieldRenderer
                                pageIdentifier={id ? "album.edit" : "album.create"}
                                entityType="album"
                                entityId={id}
                                onChange={setCustomFieldValues}
                            />
                        </div>

                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text={labelDisplay?.[5]?.title} />
                        <MessageLabel text={labelDisplay?.[6]?.title} className="mandatorySimple" />
                        <MessageSubHeading text={labelDisplay?.[6]?.sub_title} />

                        <AdminImageUploadZone
                            onChange={(e) => handleFileChange(e, ['image/jpeg', 'image/png', 'image/jpg'])}
                            selectedFile={coverImageFile}
                            uploadedImage={formData?.album_url}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.image = el)}
                            name="image"
                            id={id}
                            idAttribute="albumImage"
                            accept="image/jpeg,image/png,image/jpg"
                            error={formDataError?.image}
                        />


                        <MessageLabel text={labelDisplay?.[7]?.title} className="" />

                        <div className="mt-2">
                            <div >{id && formData?.copyrights && (
                                <AdminCustomURLCopy
                                    link={formData?.copyrights}
                                    fieldName=""
                                    className="copy-board-input"
                                    labelClassName="mt-md-2"
                                />
                            )}
                            </div>
                            <div className=" d-flex">
                                {/* Upload Area */}
                                <div className="col-sm-2 col-lg-4">
                                    <div
                                        className={`imagedrop-error-border-album-border ${formDataError?.copyright ? "error-border-album-border" : ""}`}
                                        onClick={() => fileInputRef1.current.click()}
                                    >
                                        <input
                                            type="file"
                                            ref={fileInputRef1}
                                            id="fileInputRef1"
                                            onChange={(event) =>
                                                handlePDFChange(event, fileInputRef1, setSelectedFile1, "copyright")
                                            }
                                            accept=".pdf"
                                            style={{ display: "none" }}
                                        />
                                        <span>Select PDF File</span>
                                    </div>
                                    {formDataError?.copyright && (
                                        <div className="errorred mt-1">{formDataError?.copyright}</div>
                                    )}
                                </div>
                                {/* PDF Preview + Delete */}
                                <div className="col-sm-2 col-lg-2">
                                    {selectedFile1 && (
                                        <a
                                            href={URL.createObjectURL(selectedFile1)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <div className="imagedrop-error-border-album-border position-relative ms-5">
                                                <div className="pdf-preview-container">
                                                    <a
                                                        href={URL.createObjectURL(selectedFile1)}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        View PDF
                                                    </a>
                                                </div>
                                                <button
                                                    onClick={() => handleDelete(1)}
                                                    type="button"
                                                    className="btn-close-custom"
                                                    aria-label="Close"
                                                >
                                                    ×
                                                </button>
                                            </div>
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </RightWrapper>
                <AdminCustomButton className='px-3 py-1 me-3 me-md-0 ms-md-auto' loading={showOverlay} saveMethod={handleSubmit} saveText={!id ? labelDisplay?.[0]?.title : labelDisplay?.[0]?.sub_title} />
            </FormContainer>
        </div >
    )
}

export default AudioAlbumAddUpdate